import styled from 'styled-components';

export const Wrapper = styled.section`
	.top-section {
		margin-top: 10rem;
		.pDefault {
			margin-top: 1.9375rem;
			margin-bottom: 4.375rem;
		}
	}
	.content-wrapper {
		background-color: #f9fbff;
		padding-top: 3.375rem;
		padding-bottom: 9.25rem;
		.content {
			background-color: #ffffff;
			padding: 2.5rem 1.9375rem;
			.pDefault {
				p {
					font-family: Nunito, sans-serif;
					font-style: normal;
					font-size: 16px;
					line-height: 150%;
					span {
						font-style: normal;
						font-weight: bold;
					}
				}
				ul,
				ol {
					padding-left: 1rem;
				}
			}
		}
	}
`;

export default Wrapper;
